import { Button, styled } from '@mui/material';
import { useLanguage } from '../../../context/LanguageContext';

const ToggleButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'displayVariant',
})<{ displayVariant: 'menu' | 'solo' }>(({ displayVariant }) => ({
  position: displayVariant === 'menu' ? 'static' : 'fixed',
  top: displayVariant === 'menu' ? undefined : '20px',
  right: displayVariant === 'menu' ? undefined : '80px',
  zIndex: 1000,
}));

const ChangeLanguage = ({
  isMobile,
  variant,
}: {
  isMobile: boolean;
  variant: 'menu' | 'solo';
}) => {
  const { language, toggleLanguage } = useLanguage();
  return (
    <ToggleButton displayVariant={variant} onClick={toggleLanguage}>
      {language === 'fr'
        ? isMobile
          ? '🇫🇷'
          : '🇫🇷 Français'
        : isMobile
          ? '🇬🇧'
          : '🇬🇧 English'}
    </ToggleButton>
  );
};

export default ChangeLanguage;
